<script setup lang="ts">
import type { ParsedContent } from '@nuxt/content'
import type { PropType } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  class: {
    default: undefined,
    type: [
      String,
      Object,
      Array,
    ] as PropType<any>,
  },
  icon: {
    default: undefined,
    type: String,
  },
  link: {
    required: true,
    type: Object as PropType<Pick<ParsedContent, string>>,
  },
  ui: {
    default: () => ({}),
    type: Object as PropType<Partial<typeof config>>,
  },
})

const localePath = useLocalePath()

const config = {
  description: 'text-sm font-normal text-gray-500 dark:text-gray-400 line-clamp-2 text-balance',
  icon: {
    base: 'w-5 h-5 text-gray-900 dark:text-white group-hover:text-primary',
    wrapper: 'inline-flex items-center rounded-full p-1.5 ring-1 ring-gray-300 dark:ring-gray-700 mb-4 group-hover:ring-primary/50',
  },
  title: 'font-medium text-gray-900 dark:text-white text-[15px] mb-1 text-balance',
  wrapper: 'block px-6 py-8 border not-prose rounded-lg gradient-texture hover:gradient-texture-light spring-duration-300 spring-bounce-20 transition-all border-gray-200 dark:border-gray-800 group',
}

const { attrs, ui } = useUI('content.surround.link', toRef(props, 'ui'), config, toRef(props, 'class'), true)
</script>

<template>
  <NuxtLink
    :class="ui.wrapper"
    :to="localePath({ path: (link as ParsedContent)._path })"
    v-bind="attrs"
  >
    <div
      v-if="icon || (link as ParsedContent).icon"
      :class="ui.icon.wrapper"
    >
      <UIcon
        :class="ui.icon.base"
        :name="icon || (link as ParsedContent).icon"
      />
    </div>

    <p :class="ui.title">
      {{ (link as ParsedContent).title }}
    </p>

    <p :class="ui.description">
      {{ (link as ParsedContent).description }}
    </p>
  </NuxtLink>
</template>
